// src/components/company/TermsAndCondition.js
import React from "react";

const TermsAndCondition = () => {
    return (
        <div className="p-6 bg-gray-100 min-h-screen">
            <div className="max-w-4xl mx-auto bg-white shadow-lg rounded-lg p-8 space-y-8">

                <h1 className="text-3xl font-bold text-gray-800 mb-4">Terms and Conditions</h1>
                <p className="text-sm text-gray-600 mb-4">Effective Date: 01 Jan 2025</p>
                <p className="text-gray-700 leading-relaxed mb-6">
                    These Terms and Conditions ("Terms") govern your access to and use of the Apps
                    launched by CodeBasera Technologies. By accessing or using any of the App, you
                    agree to be bound by these Terms. If you do not agree, you must not use the App.
                </p>

                <section className="space-y-6">
                    <h2 className="text-xl font-semibold text-gray-800">1. Acceptance of Terms</h2>
                    <div className="space-y-4">
                        <div>
                            <h3 className="text-lg font-medium text-gray-700 mb-2">1.1 Binding Agreement</h3>
                            <p className="text-gray-700 leading-relaxed">
                                By downloading, accessing, or using the App, you confirm that you have
                                read, understood, and agreed to these Terms.
                            </p>
                        </div>
                        <div>
                            <h3 className="text-lg font-medium text-gray-700 mb-2">1.2 Mandatory Acceptance</h3>
                            <p className="text-gray-700 leading-relaxed">
                                You must accept these Terms before you can start using the App.
                            </p>
                        </div>
                    </div>
                </section>

                <section className="space-y-6">
                    <h2 className="text-xl font-semibold text-gray-800">2. Eligibility</h2>
                    <div className="space-y-4">
                        <div>
                            <h3 className="text-lg font-medium text-gray-700 mb-2">2.1 Community Membership</h3>
                            <p className="text-gray-700 leading-relaxed">
                                The App is intended only for verified members of the corresponding
                                community. If it is determined that an outsider has accessed the App
                                not belonging to their community, their actions may be reported to the
                                relevant law authorities for impersonation or fraud.
                            </p>
                        </div>
                        <div>
                            <h3 className="text-lg font-medium text-gray-700 mb-2">2.2 Age Requirement</h3>
                            <p className="text-gray-700 leading-relaxed">
                                Users must be at least 18 years old to use the App independently. Users
                                under 18 must have parental or guardian supervision.
                            </p>
                        </div>
                    </div>
                </section>

                <section className="space-y-6">
                    <h2 className="text-xl font-semibold text-gray-800">3. Account Registration</h2>
                    <div className="space-y-4">
                        <div>
                            <h3 className="text-lg font-medium text-gray-700 mb-2">3.1 User Responsibilities</h3>
                            <p className="text-gray-700 leading-relaxed">
                                You must provide accurate and truthful information during registration.
                                Users are responsible for maintaining the confidentiality of their account credentials.
                            </p>
                        </div>
                        <div>
                            <h3 className="text-lg font-medium text-gray-700 mb-2">3.2 Community Verification</h3>
                            <p className="text-gray-700 leading-relaxed">
                                The App reserves the right to verify your community membership and reject or suspend accounts that fail this verification.
                            </p>
                        </div>
                        <div>
                            <h3 className="text-lg font-medium text-gray-700 mb-2">3.3 Abuse and Violations</h3>
                            <p className="text-gray-700 leading-relaxed">
                                We reserve the right to remove or delete accounts, posts, comments, or other content that is abusive, harmful, or violates these Terms.
                            </p>
                        </div>
                    </div>
                </section>

                <section className="space-y-6">
                    <h2 className="text-xl font-semibold text-gray-800">4. Data Use and Protection</h2>
                    <div className="space-y-4">
                        <div>
                            <h3 className="text-lg font-medium text-gray-700 mb-2">4.1 Scraping and Unauthorized Access</h3>
                            <p className="text-gray-700 leading-relaxed">
                                Users are prohibited from scraping, harvesting, or accessing App data through automated means or interfaces other than those provided by the App.
                            </p>
                        </div>
                        <div>
                            <h3 className="text-lg font-medium text-gray-700 mb-2">4.2 Privacy</h3>
                            <p className="text-gray-700 leading-relaxed">
                                You must not misuse any personal or family-related information of other users.
                            </p>
                        </div>
                    </div>
                </section>

                <section className="space-y-6">
                    <h2 className="text-xl font-semibold text-gray-800">5. Content Guidelines</h2>
                    <div className="space-y-4">
                        <div>
                            <h3 className="text-lg font-medium text-gray-700 mb-2">5.1 Prohibited Content</h3>
                            <p className="text-gray-700 leading-relaxed">
                                Users are not allowed to post content that is offensive, defamatory, harmful, or discriminatory.
                                Violations may result in removal of content and suspension or termination of the account.
                            </p>
                        </div>
                        <div>
                            <h3 className="text-lg font-medium text-gray-700 mb-2">5.2 Content Ownership</h3>
                            <p className="text-gray-700 leading-relaxed">
                                You retain ownership of any content you upload, but you grant the App a non-exclusive license to use it for community-building purposes.
                            </p>
                        </div>
                    </div>
                </section>

                <section className="space-y-6">
                    <h2 className="text-xl font-semibold text-gray-800">6. Donation Management</h2>
                    <div className="space-y-4">
                        <div>
                            <h3 className="text-lg font-medium text-gray-700 mb-2">6.1 One-Time and Recurring Donations</h3>
                            <p className="text-gray-700 leading-relaxed">
                                Donations made to registered community organizations are final and non-refundable.
                                Users can pause, cancel, or restart recurring donations.
                            </p>
                        </div>
                        <div>
                            <h3 className="text-lg font-medium text-gray-700 mb-2">6.2 Receipts</h3>
                            <p className="text-gray-700 leading-relaxed">
                                A receipt will be provided for every transaction.
                            </p>
                        </div>
                        <div>
                            <h3 className="text-lg font-medium text-gray-700 mb-2">6.3 Registered Organizations</h3>
                            <p className="text-gray-700 leading-relaxed">
                                Only verified organizations with 80G certification can collect donations through the App.
                            </p>
                        </div>
                    </div>
                </section>

                <section className="space-y-6">
                    <h2 className="text-xl font-semibold text-gray-800">7. Limitation of Liability</h2>
                    <div className="space-y-4">
                        <div>
                            <h3 className="text-lg font-medium text-gray-700 mb-2">7.1 No Warranties</h3>
                            <p className="text-gray-700 leading-relaxed">
                                The App is provided "as is" without warranties of any kind, express or implied.
                            </p>
                        </div>
                        <div>
                            <h3 className="text-lg font-medium text-gray-700 mb-2">7.2 Limited Responsibility</h3>
                            <p className="text-gray-700 leading-relaxed">
                                The App is not liable for technical issues, data loss, or the actions of third-party organizations using the platform.
                            </p>
                        </div>
                    </div>
                </section>

                <section className="space-y-6">
                    <h2 className="text-xl font-semibold text-gray-800">8. Termination of Access</h2>
                    <p className="text-gray-700 leading-relaxed">
                        The App reserves the right to terminate or suspend accounts for violations of these Terms, misuse, or any activities deemed inappropriate.
                    </p>
                </section>

                <section className="space-y-6">
                    <h2 className="text-xl font-semibold text-gray-800">9. Jurisdiction and Governing Law</h2>
                    <p className="text-gray-700 leading-relaxed">
                        These Terms shall be governed by the laws of India.
                        Any disputes arising under these Terms shall be subject to the exclusive jurisdiction of the courts in Jodhpur, Rajasthan.
                    </p>
                </section>

                <section className="space-y-6">
                    <h2 className="text-xl font-semibold text-gray-800">10. Changes to These Terms</h2>
                    <p className="text-gray-700 leading-relaxed">
                        The App reserves the right to update these Terms at any time. Significant changes will be notified to users through the App.
                    </p>
                </section>

                <section className="space-y-4">
                    <h2 className="text-xl font-semibold text-gray-800">11. Contact Us</h2>
                    <p className="text-gray-700 leading-relaxed">
                        For any questions or concerns about these Terms, please contact us:
                    </p>
                    <p className="text-gray-700 font-medium">Email: contact@codebasera.com</p>
                </section>
            </div>
        </div>
    );
};

export default TermsAndCondition;
